// @ts-expect-error migrate upstream
import { connect } from 'general-store';
import { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import compose from 'transmute/compose';
import { CUSTOM_DASHBOARD_COUNT, CUSTOM_DASHBOARD_LIMIT, DASHBOARD_CREATED_AT_TIMESTAMP, DASHBOARD_IS_CUSTOM, IS_READ_ONLY_DEMO, MAX_USER_ASSET_PERMISSION, USER_DASHBOARD_PERMISSION
// @ts-expect-error migrate upstream
} from 'dashboard-lib/private/action-problem-solution/params/all-params';
import GranularPermissionActionButton from './GranularPermissionActionButton';
// @ts-expect-error migrate upstream
import { selectHasGranularPermissionsAccess } from 'dashboard-lib/public/userInfo/gates';
import { getCreatedAt, getId, getName, getOwnerId
// @ts-expect-error migrate upstream
} from 'dashboard-lib/public/dashboard/dashboard-schema';
// @ts-expect-error migrate upstream
import { getSetDashboardPermissionProblem } from 'dashboard-lib/public/enable-action/set-dashboard-permission';
// @ts-expect-error migrate upstream
import { getDisabledProblemMessage } from 'dashboard-components/disabled-message/actions/set-dashboard-permission';
import { fetchDashboardConfigSingle, fetchDashboardConfigSingleGranular
// @ts-expect-error migrate upstream
} from 'dashboard-lib/public/permission/permission-action';
import { isCustomDashboard, isReadOnlyDemo
// @ts-expect-error migrate upstream
} from 'dashboard-lib/public/dashboard/dashboard-logic';
// @ts-expect-error migrate upstream
import { selectUserMaxAssetPermission } from 'dashboard-lib/public/userInfo/permissions';
// @ts-expect-error migrate upstream
import { selectHasDashboardDemoWriteScope } from 'dashboard-lib/public/userInfo/scopes';
// @ts-expect-error migrate upstream
import { createMessage } from 'dashboard-components/message/message';
import PermissionActionButton from './PermissionActionButton';
// @ts-expect-error migrate upstream
import { useDashboardPermission } from 'dashboard-components/permission/useDashboardPermission';
// @ts-expect-error migrate upstream
import { fetchTeamHierarchy } from 'dashboard-lib/public/team/team-hierarchy-action';
// @ts-expect-error migrate upstream
import { fetchAllTeam } from 'dashboard-lib/public/team/team-action';
// @ts-expect-error migrate upstream
import { useCustomDashboardLimit } from 'dashboard-components/context/use-custom-dashboard-limit';
// @ts-expect-error migrate upstream
import { DashboardCountDependency } from '../../../dependencies/DashboardsDependency';
// @ts-expect-error migrate upstream
import toClass from '../../../decorators/toClass';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PermissionLabelMessage = createMessage('dashboard.action.permission.label.assigned');
const PermissionLabelButton = props => {
  const {
    dashboard,
    customDashboardCount
  } = props;
  const hasGranularPermissionsAccess = useSelector(selectHasGranularPermissionsAccess);
  const dashboardId = getId(dashboard);
  const dashboardName = getName(dashboard);
  const dashboardOwnerId = getOwnerId(dashboard);
  const dashboardPermission = useDashboardPermission(dashboardId);
  const customDashboardLimit = useCustomDashboardLimit();
  const maxUserAssetPermission = useSelector(selectUserMaxAssetPermission);
  const canWriteDemoDashboard = useSelector(selectHasDashboardDemoWriteScope);
  const params = {
    [USER_DASHBOARD_PERMISSION]: dashboardPermission,
    [DASHBOARD_IS_CUSTOM]: isCustomDashboard(dashboard),
    [DASHBOARD_CREATED_AT_TIMESTAMP]: getCreatedAt(dashboard),
    [CUSTOM_DASHBOARD_COUNT]: customDashboardCount,
    [CUSTOM_DASHBOARD_LIMIT]: customDashboardLimit,
    [MAX_USER_ASSET_PERMISSION]: maxUserAssetPermission,
    [IS_READ_ONLY_DEMO]: isReadOnlyDemo(canWriteDemoDashboard, dashboard)
  };
  const problem = getSetDashboardPermissionProblem(params);
  const Message = getDisabledProblemMessage({}, problem);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginInlineEnd: "200",
      as: "span",
      children: /*#__PURE__*/_jsx(PermissionLabelMessage, {})
    }), hasGranularPermissionsAccess ? /*#__PURE__*/_jsx(GranularPermissionActionButton, {
      dashboardId: dashboardId,
      dashboardName: dashboardName,
      disabled: !!problem,
      DisabledMessage: Message,
      dashboardOwnerId: dashboardOwnerId
    }) : /*#__PURE__*/_jsx(PermissionActionButton, {
      dashboardId: dashboardId,
      dashboardName: dashboardName,
      disabled: !!problem,
      DisabledMessage: Message
    })]
  });
};
const _PermissionActionContainer = ({
  dashboard,
  customDashboardCount
}) => {
  const dashboardId = getId(dashboard);
  const hasGranularPermissionsAccess = useSelector(selectHasGranularPermissionsAccess);
  const dispatch = useDispatch();
  useEffect(() => {
    const configAction = hasGranularPermissionsAccess ? fetchDashboardConfigSingleGranular({
      dashboardId
    }) : fetchDashboardConfigSingle({
      dashboardId
    });
    const teamHierarchyAction = fetchTeamHierarchy();
    const teamAction = fetchAllTeam();
    dispatch(configAction);
    dispatch(teamAction);
    dispatch(teamHierarchyAction);
  }, [dashboardId, dispatch, hasGranularPermissionsAccess]);
  return /*#__PURE__*/_jsx(View, {
    marginInlineStart: "800",
    as: "div",
    children: /*#__PURE__*/_jsx(PermissionLabelButton, {
      dashboard: dashboard,
      customDashboardCount: customDashboardCount
    })
  });
};
export const PermissionActionContainer = compose(connect({
  customDashboardCount: DashboardCountDependency
}), toClass)(_PermissionActionContainer);